import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

import { BoolPipe, CentsToEuroPipe, ColumnEnum, EnumPipe, ListMappedPropertyToStringPipe, StatePipe } from '@mysvg/utils';
import { VehicleDocumentsPipe } from '@svg-frontends/document';

@Pipe({
	name: 'column',
	standalone: false,
})
export class ColumnPipe implements PipeTransform {
	private boolPipe = inject(BoolPipe);
	private currencyPipe = inject(CurrencyPipe);
	private datePipe = inject(DatePipe);
	private enumPipe = inject(EnumPipe);
	private listPropertyPipe = inject(ListMappedPropertyToStringPipe);
	private percentPipe = inject(PercentPipe);
	private statePipe = inject(StatePipe);
	private vehicleDocumentsPipe = inject(VehicleDocumentsPipe);
	private centsToEuroPipe = inject(CentsToEuroPipe);

	private columns = ColumnEnum;

	transform(obj: any, columnName: string, property: string = null, isExport: boolean = false): any {
		const column = this.columns[columnName];

		const isNotDefined = !column || !column.pipe;
		const isUnknownPipe = !isNotDefined && this.getPipeFromKey(column.pipe) === null;

		if (!property) {
			property = columnName;
		}

		if (isNotDefined || isUnknownPipe || (isExport && column.pipe === 'currency')) {
			return obj[property];
		} else if (isExport && column.pipe === 'centsToEuro') {
			return obj[property] !== null && !isNaN(obj[property]) ? obj[property] / 100 : obj[property];
		} else {
			if (column.pipeArgs) {
				return this.getPipeFromKey(column.pipe).transform(obj[property], ...column.pipeArgs);
			} else {
				return this.getPipeFromKey(column.pipe).transform(obj[property]);
			}
		}
	}

	private getPipeFromKey(key: string): any | null {
		switch (key) {
			case 'bool':
				return this.boolPipe;
			case 'currency':
				return this.currencyPipe;
			case 'date':
				return this.datePipe;
			case 'enum':
				return this.enumPipe;
			case 'centsToEuro':
				return this.centsToEuroPipe;
			case 'percent':
				return this.percentPipe;
			case 'state':
				return this.statePipe;
			case 'vehicle-documents':
				return this.vehicleDocumentsPipe;
			case 'list-mapped-property-to-string':
				return this.listPropertyPipe;
			default:
				return null;
		}
	}
}
